/*! dependencies: cash */

var gtag = gtag || null;
if (gtag) {
  cash('body').on('click', 'a[href^="mailto:"], a[href^="tel:"]', function () {
    var clickedEle = cash(this),
      url = clickedEle.attr('href').replace('mailto:', '').replace('tel:', '');

    gtag('event', 'clicked', {
      'event_category': 'Contact link',
      'event_label': url
    });
  });
}
